import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import Terms from "./pages/Terms";
import WebDesignTerms from "./pages/WebDesignTerms";
import Admin from "./pages/Admin";
import AdminReset from "./pages/AdminReset";
import TownPage from "./pages/TownPage";
import { TOWN_PAGES } from "./towns";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/web-design-terms" element={<WebDesignTerms />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/reset" element={<AdminReset />} />
          {TOWN_PAGES.map((t) => (
            <Route key={t.slug} path={`/${t.slug}`} element={<TownPage town={t} />} />
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
